import React, { Component } from 'react';
import {
  connect, ApiResponseHelper, moment, testClass, PrivilegeChecker, Grid, Store,
} from 'omni-common-ui';
import TabSwitcher, { TabCodes } from 'domain/TabSwitcher';

import { bindActionCreators } from 'redux';
import is from 'is_js';
import { List } from 'immutable';
import Privileges from 'domain/Privileges';
import { calculateDefaultSession } from 'data/SessionPlans/accessors';
import { actions as progressTestsPlanActions } from 'data/ProgressTestsPlan';
import { actions as courseProgressActions } from 'data/CourseProgress';
import { actions as Group } from 'containers/Group';
import { actions as GroupPerformance } from 'data/GroupPerformance';
import GroupDetail from './GroupDetail';
import CourseProgress from './CourseProgress';
import PerformanceCard from './PerformanceCard';
import PerformanceCardRAv2 from './PerformanceCardRAv2';
import PropTypes from 'prop-types';

export class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = { isExpandGroupDetail: false };
  }

  componentWillMount() {
    const {
      courseProgress,
    } = this.props;
    const { groupId } = this.props.params;
    const isKETGroup = Group.isKETCourseTypeGroup(this.props.state, groupId);
    if (! isKETGroup &&
        PrivilegeChecker.hasPrivilege(this.props.state,
        Privileges.GroupDashboard.ViewGroupMemberInfo)) {
      this.props.fetchGroupPerformance(groupId);
    }

    this._calculateDefaultSessionId(this.props);

    if (! isKETGroup &&
        ApiResponseHelper.shouldFetch(courseProgress) &&
        PrivilegeChecker.hasPrivilege(this.props.state,
            Privileges.GroupDashboard.ViewGroupBasicInfo)) {
      this.props.fetchCourseProgress(groupId);
    }
  }

  componentWillReceiveProps(props) {
    this._calculateDefaultSessionId(props);
  }

  _calculateDefaultSessionId(props) {
    const { sessionPlans } = props;
    if (is.existy(props.params.sessionPlanId) ||
        ! List.isList(sessionPlans.data)) {
      return;
    }

    const defaultSession = calculateDefaultSession(sessionPlans.data, props.now);
    const defaultSessionId = is.object(defaultSession) ?
        defaultSession.id :
        undefined;

    this.setState({ defaultSessionId });
  }

  _expandGroupDetail() {
    const { isExpandGroupDetail } = this.state;
    this.setState({ isExpandGroupDetail: ! isExpandGroupDetail });
  }

  _renderGroupDetail() {
    if (! PrivilegeChecker
      .hasPrivilege(this.props.state, Privileges.GroupDashboard.ViewGroupBasicInfo)) {
      return false;
    }

    const { groupSummary, timeZone } = this.props;

    if (is.undefined(groupSummary) || is.null(groupSummary)) {
      return false;
    }

    const { isExpandGroupDetail } = this.state;
    return <GroupDetail groupSummary={groupSummary}
        isExpanded={isExpandGroupDetail}
        onExpandBottonClick={() => this._expandGroupDetail()}
        timeZone={timeZone} />;
  }

  _renderProgressBar() {
    if (! PrivilegeChecker
      .hasPrivilege(this.props.state, Privileges.GroupDashboard.ViewGroupBasicInfo)) {
      return false;
    }

    const { courseProgress } = this.props;

    if (! courseProgress || ! courseProgress.sessions) {
      return null;
    }

    const highLightEvents = this._getHighLightEvents(courseProgress.sessions);
    const currentEvent = this._getCurrentEvent(courseProgress.sessions);
    const totalSessionNumber = courseProgress.sessions ?
        courseProgress.sessions.length :
        0;
    const groupStartDate = courseProgress.groupStartDate;
    const groupEndDate = courseProgress.groupEndDate;
    const startEvent = this._getStartOrEndGroupEvent(groupStartDate);
    const endEvent = this._getStartOrEndGroupEvent(groupEndDate, false);
    const GROUP_PROGRESS_UN_START = 0;
    const GROUP_PROGRESS_END = 2;

    if (courseProgress.groupProgress === GROUP_PROGRESS_UN_START) {
      currentEvent.percentage = 0;
    } else if (courseProgress.groupProgress === GROUP_PROGRESS_END) {
      currentEvent.percentage = 100;
    }

    return <CourseProgress startEvent={startEvent}
        endEvent={endEvent}
        currentEvent={currentEvent}
        highLightEvents={highLightEvents}
        totalSessionNumber={totalSessionNumber}
        startWeekNumber={this.props.courseProgress.startWeekCode}
        endWeekNumber={this.props.courseProgress.endWeekCode} />;
  }

  _getVisibleColumnsInAveragesOverview() {
    let columns = new List([
      'averageTotalScore',
      'averageOnlineHomeworkCompletion',
      'averageOnlineHomeworkAccuracy',
      'averagePaperBasedHomeworkCompletion',
      'ach',
    ]);

    const { groupId } = this.props;
    const state = Store.get().getState();

    if (! Group.shouldShowAch(state, groupId)) {
      columns = columns.filterNot((col) => col === 'ach');
    }

    if (! Group.hasPaperBasedHomework(state, groupId)) {
      columns = columns.filterNot((col) => col === 'averagePaperBasedHomeworkCompletion');
    }

    if (Group.isSSCourseTypeGroup(state, groupId) &&
        ! TabSwitcher.isTabEnabled(state, groupId, TabCodes.SmallStarsApp)) {
      columns = columns.filterNot((col) => col === 'averageOnlineHomeworkCompletion');
    }

    if (! Group.isHFV4CourseTypeGroup(state, groupId)) {
      columns = columns.filterNot((col) => col === 'averageOnlineHomeworkAccuracy');
    }

    if (Group.isHFV4CourseTypeGroup(state, groupId)) {
      columns = columns.filterNot((col) => col === 'averageTotalScore');
    }

    return columns;
  }

  _getColumnLabelsInAveragesOverview() {
    const { groupId } = this.props;
    const state = Store.get().getState();

    return Group.isHFV4CourseTypeGroup(state, groupId) ?
      { averageOnlineHomeworkCompletion: 'Avg. Completion', averageOnlineHomeworkAccuracy: 'Avg. Accuracy' } :
      {};
  }

  _disableSwitchTableInPerformanceCard() {
    const { groupId } = this.props;
    const state = Store.get().getState();

    return Group.isHFV4CourseTypeGroup(state, groupId);
  }

  _renderPerformanceCard() {
    const {
      groupPerformance,
      isLoadingGroupPerformance,
      groupId,
     } = this.props;

    const state = Store.get().getState();
    if (Group.isRAv2CourseTypeGroup(state, groupId)) {
      return <PerformanceCardRAv2 params={this.props.params} />;
    }

    if (isLoadingGroupPerformance === true) {
      return <div className={testClass('groudPerformance-loading-view')}>Loading…</div>;
    }

    if (! groupPerformance ||
      groupPerformance.currentUnitNumber === - 1 ||
      groupPerformance.currentUnitNumber === 0) {
      return null;
    }

    return <PerformanceCard location={this.props.location}
        groupPerformance={groupPerformance}
        groupId={groupId}
        sessionId={this.state.defaultSessionId}
        disableSwitchTable={this._disableSwitchTableInPerformanceCard()}
        visibleOptionalColumnsInAveragesOverview={this._getVisibleColumnsInAveragesOverview()}
        columnLabelsInAveragesOverview={this._getColumnLabelsInAveragesOverview()} />;
  }

  _getStartSession(sessions) {
    return this._getStartOrEndSession(sessions);
  }

  _getLastSession(sessions) {
    return this._getStartOrEndSession(sessions, false);
  }

  _getStartOrEndSession(sessions, isStart = true) {
    if (sessions.length > 0) {
      const index = isStart ? 0 : sessions.length - 1;
      const sessionDate = sessions[index].actualPeriod.startDate ?
          sessions[index].actualPeriod.startDate :
          sessions[index].plannedPeriod.startDate;
      const session = {
        date: this._formatDate(sessionDate, 'YYYY-MM-DD'),
        percentage: isStart ? 0 : 100,
      };
      return session;
    }
    return { date: '', percentage: isStart ? 0 : 100 };
  }

  _getStartOrEndGroupEvent(date, isStart = true) {
    return {
      date: this._formatDate(date, 'YYYY-MM-DD'),
      percentage: isStart ? 0 : 100,
    };
  }

  _getHighLightEvents(sessions) {
    const highLightEvents = [];
    sessions.map((session) => {
      if (session.isHighLight) {
        const event = this._transFormSessionToEvent(session, sessions);
        highLightEvents.push(event);
      }
      return false;
    });

    return highLightEvents;
  }

  _transFormSessionToEvent(session, sessions) {
    const date = session.actualPeriod.endDate ?
        session.actualPeriod.endDate :
        session.plannedPeriod.startDate;
    const currentIndex = sessions.indexOf(session);
    let content = session.sessionTypeCode === 'PTC' ? 'PTC' : session.sessionType;
    const type = session.hasProgressTest ? 'progressTest' : 'events';
    const percentage = ((currentIndex + 2) / (sessions.length + 2)) * 100;

    if (session.hasProgressTest) {
      content = session.progressTestName;
    }

    return {
      date: this._formatDate(date, 'YYYY-MM-DD'),
      content,
      percentage,
      type,
      currentIndex,
    };
  }

  _getCurrentEvent(sessions) {
    let currentEvent = { date: '', content: '', percentage: 0, currentIndex: 0 };
    sessions.map((session) => {
      if (session.isMostRecent) {
        currentEvent = this._transFormSessionToEvent(session, sessions);
        currentEvent.content = `Session ${currentEvent.currentIndex + 1}/${sessions.length}`;
      }
      return false;
    });
    return currentEvent;
  }

  _formatDate(dataString, customFormat) {
    // TODO: Suppresses a random race condition problem that could have been caused
    //       by any one of several calling components. Try to fix this in a better way.
    let _moment = moment.utc(dataString).clone().tz(this.props.timeZone);
    if (! _moment) {
      _moment = moment.utc(dataString);
    }
    return _moment.format(customFormat);
  }

  render() {
    const { groupId } = this.props;
    const state = Store.get().getState();
    if (Group.isKETCourseTypeGroup(state, groupId)) {
      return <Grid outerMargin>
        <Grid.Group>
          <Grid.Item>{this._renderGroupDetail()}</Grid.Item>
        </Grid.Group>
      </Grid>;
    }

    return <Grid outerMargin>
      <Grid.Group>
        <Grid.Item>{this._renderGroupDetail()}</Grid.Item>
        <Grid.Item>{this._renderProgressBar()}</Grid.Item>
        <Grid.Item>{this._renderPerformanceCard()}</Grid.Item>
      </Grid.Group>
    </Grid>;
  }
}

Dashboard.propTypes = {
  state: PropTypes.object.isRequired,
  group: PropTypes.object.isRequired,
  groupId: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
  params: PropTypes.shape({
    mode: PropTypes.string,
    groupId: PropTypes.string,
    sessionPlanId: PropTypes.string,
  }),
  buildRoute: PropTypes.func.isRequired,
  sessionPlans: PropTypes.object.isRequired,
  groupSummary: PropTypes.object.isRequired,
  courseProgress: PropTypes.object.isRequired,
  fetchCourseProgress: PropTypes.func.isRequired,
  fetchProgressTestsPlan: PropTypes.func.isRequired,
  now: PropTypes.object.isRequired,
  timeZone: PropTypes.string,
  groupPerformance: PropTypes.object,
  isLoadingGroupPerformance: PropTypes.bool,
  fetchGroupPerformance: PropTypes.func.isRequired,
};

export function mapStateToProps(state, ownProps) {
  const groupId = ownProps.params.groupId;
  const { timeZone } = Group.getCentre(state, groupId);
  const sessionPlans = getSessionPlans(state, groupId);
  const groupSummary = getGroupSummary(state, groupId);
  const group = state.get('rootReducer').get('groups').get(groupId);
  const courseProgress = getCourseProgress(state);
  const groupPerformance = GroupPerformance.getGroupPerformanceByGroupId(state, groupId);
  const isLoadingGroupPerformance = GroupPerformance.isLoadingGroupPerformance(state, groupId);
  return {
    state,
    group,
    groupId,
    timeZone,
    sessionPlans,
    groupSummary,
    courseProgress,
    groupPerformance,
    isLoadingGroupPerformance,
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign(
    bindActionCreators(courseProgressActions, dispatch),
    bindActionCreators(progressTestsPlanActions, dispatch),
    bindActionCreators(GroupPerformance, dispatch),
  );
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  const now = moment();
  return Object.assign({ now }, ownProps, stateProps, dispatchProps);
}

function getSessionPlans(state, groupId) {
  let { sessionPlans } = state.get('rootReducer').get('groups').get(groupId).data;
  if (ApiResponseHelper.shouldFetch(sessionPlans) ||
      ! ApiResponseHelper.hasSucceeded(sessionPlans)) {
    return sessionPlans;
  }

  sessionPlans = sessionPlans.update('data', (data) =>
      data.map((sessionPlanId) => state.get('rootReducer')
        .get('sessionPlans')
        .get(sessionPlanId)));
  sessionPlans = sessionPlans.update('data', (data) => new List(data));
  return sessionPlans;
}

function getGroupSummary(state, groupId) {
  const { groupSummary } = state.get('rootReducer').get('groups').get(groupId).data;
  return groupSummary;
}

function getCourseProgress(state) {
  const courseProgressSessions = state.get('rootReducer').get('courseProgress');
  return courseProgressSessions;
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Dashboard);



// WEBPACK FOOTER //
// ./containers/Group/Dashboard/index.jsx